import type * as React from "react";

export interface FontFace {
  /**
   * The name of the typeface as it's published by the foundry.
   *
   * Example: "Circular Pro Medium Italic"
   */
  name: string;

  /**
   * The font-family name in the @font-face declaration.
   */
  fontFamily: React.CSSProperties["fontFamily"];

  /**
   * Fallback font families. Include "serif" or "sans-serif" as the
   * last entry in the list.
   *
   * Example: ["sans-serif"]
   */
  fallback: React.CSSProperties["fontFamily"][];

  /**
   * CSS properties like font-weight and font-style, which must be consistent
   * across the base font and all fallback fonts.
   */
  cssProperties: React.CSSProperties;
}
// -----------------------------------------------------------------------------
// Font stacks

export type FontStack = Pick<FontFace, "fontFamily" | "fallback">;

export const mkFontStack = ({ fontFamily, fallback }: FontStack) => [fontFamily, ...fallback].join(",");

const notoStack = {
  fontFamily: "Noto Sans",
  fallback: [
    "Noto Sans SC",
    "Noto Naskh Arabic",
    "Verdana",
    "-apple-system",
    "BlinkMacSystemFont",
    "Segoe UI",
    "Roboto",
    "PingFang SC",
    "Microsoft YaHei",
    "sans-serif",
  ],
};

// -----------------------------------------------------------------------------
// Font-face definitions

export const notoRegular: FontFace = {
  name: "Noto Regular",
  ...notoStack,
  cssProperties: {
    fontWeight: 400,
    fontStyle: "normal",
  },
};
